(ns net.kestec.mhda-pilgrimage.admin.cms.news-edit
  (:require
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Button" :default Button]
    [day8.re-frame.http-fx]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [net.kestec.mhda-pilgrimage.cms.editor :as editor]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.admin.cms.cms-events :as-alias cms-events]
    [re-frame.core :as rf]
    [reagent.core :as r]

    ))


(defn editNewsPage []
  (let [news-id @(rf/subscribe [::db/get ::route/route :path-params :news-id])]
    [base-page
     [:> Paper {:sx {:padding "7px"}}
      [:br]
      [editor/editor
       (str "news_" news-id ".html")
       (str "/api/news/global/" news-id "/doc")]
      [:br]
      [:br]
      [:> Button {:variant "outlined"
                  :href "/admin/setup"} "Zurück"]
      ]]))
